import WeatherMarkers from './WeatherMarkers';

export default WeatherMarkers;
